<template>
  <v-container>
    <v-row class="justify-center">
      <v-row>
        <v-col cols="12" class="pl-0 pb-0">
          <v-card-title class="breakword pb-0"
            >How do you finish and create the final look on your clients after
            applying a topper?
          </v-card-title></v-col
        >
        <v-col
          v-for="option in options"
          :key="option.value"
          class="d-flex justify-center flex-column align-center pb-0"
          :class="$vuetify.breakpoint.smAndDown ? 'px-1' : 'px-3'"
          cols="12"
          @click="handleSelect(option.value)"
        >
          <v-btn
            depressed
            :color="answer === option.value ? 'user_cta' : 'user_btn'"
            :dark="answer === option.value"
            class="text-none mt-1"
            width="95%"
            >{{ option.text }}
          </v-btn>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    data() {
      return {
        answer: '',
        options: [
          {
            text: 'I cut and blend with the clients hair',
            value: 'Yes'
          },
          {
            text: 'I just apply them with little to no cutting',
            value: 'Little to none'
          },
          {
            text: 'I do not do any cutting on the toppers',
            value: 'No'
          }
        ],
        field: 'toppersBlend',
        screen: 'stylist-restoration1_1',
        nextScreen: 'stylist-restoration2'
      }
    },
    methods: {
      ...mapActions([
        'setApplicationData',
        'setCurrentScreen',
        'setNextScreen',
        'setIsValid'
      ]),
      handleNextScreen() {
        // todo:
        this.setNextScreen(this.nextScreen)
      },
      handleSelect(answer) {
        this.answer = answer
        // 1. set data
        this.setApplicationData({ field: this.field, answer })
        // 2. set next screen depending on this component logic
        this.handleNextScreen()
        // 3. set valid depending on this component logic
        this.setIsValid(true)
        // 4. go to next screen
        this.$emit('next')
      }
    },
    created() {
      // 1. set current screen
      this.setCurrentScreen(this.screen)
      // 2. set answer, sent next screen and valid if data exists
      if (this.$store.state.applications.application[this.field]) {
        this.answer = this.$store.state.applications.application[this.field]
        this.handleNextScreen()
        this.setIsValid(true)
      }
      // 3. set valid if data doesn't exist
      else {
        this.setIsValid(false)
      }
    }
  }
</script>
<style scoped>
  .breakword {
    word-break: break-word;
  }
</style>
